import { FC } from 'react'

import styled from 'styled-components'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ModalType, ScheduleSteps } from 'src/Types/ui'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'

const StyledPrimaryDottedButton = styled(PrimaryDottedButton)`
  height: 48px;
`

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  gap: 1px;
`
const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const NoteText = styled(SubTitle)`
  font-weight: 400;
`

export const SpotifyScheduleTrackNote: FC = () => {
  const { setSearch } = useCustomSearchParams()
  const { campaignDetails } = useSpotifyCampaignStatus()

  const trackNote = campaignDetails?.trackNote

  const handleClick = (): void => {
    setSearch({ step: ScheduleSteps.SETTINGS, modal: ModalType.Comment })
  }

  if (!trackNote) {
    return (
      <StyledPrimaryDottedButton onClick={handleClick}>
        + Add track note (Optional)
      </StyledPrimaryDottedButton>
    )
  }

  return (
    <Container>
      <Wrapper>
        <SubTitle>Track note</SubTitle>
        <NoteText>{trackNote}</NoteText>
      </Wrapper>
      <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
    </Container>
  )
}
